import React, { useState } from "react"
import CustomerService from "../../../icons/svg/CustomerService"
import Money from "../../../icons/svg/Money"
import MessageOnPhone from "../../../icons/svg/MessageOnPhone"
import styled from "@emotion/styled"
import { breakpoints, color } from "../../../utils/style"

const StepsWrap = styled("div")`
  display: flex;
  margin-bottom: 40px;
  border-radius: 16px;
  overflow: hidden;
  .col {
    flex-basis: 25%;
    background: ${color.purpleGradient};
    padding: 40px 32px;
    cursor: pointer;
    border-right: 1px solid ${color.white};
    transition: 0.5s all;
    &:last-child {
      border: none;
    }
    .icon {
      text-align: right;
    }
    svg {
      path {
        fill: ${color.white};
      }
    }
    .description {
      display: none;
    }
    .step {
      font-size: 18px;
      line-height: 32px;
      font-weight: bold;
    }
    .title {
      font-weight: bold;
      font-size: 26px;
      line-height: 32px;
    }
  }
  .active-column {
    flex-basis: 50%;
    background: ${color.white};
    svg {
      path {
        fill: ${color.pink};
      }
    }
    .step {
      color: ${color.black};
    }
    .title {
      color: ${color.pink};
      font-size: 26px;
      line-height: 32px;
    }
    .description {
      color: ${color.black};
      display: block;
    }
  }
  @media (max-width: ${breakpoints.sm}) {
    flex-flow: row wrap;
    .col {
      flex-basis: 100%;
      border: none;
      .title {
        font-size: 26px;
        line-height: 32px;
      }
    }
    .active-column {
      flex-basis: 100%;
      .title {
        font-size: 26px;
        line-height: 32px;
      }
    }
  }
`

const Steps = ({ step_1, step_2, step_3 }) => {

  const [activeColumn, setActiveColumn] = useState(0)

  return (
    <StepsWrap>
      <div
        onClick={() => setActiveColumn(0)}
        onKeyPress={(e) => e.key === "13" && setActiveColumn(0)}
        role="button"
        tabIndex={1}
        className={`col step-item ${activeColumn === 0 ? "active-column" : ""}`}
      >
        <div className="icon">
          <CustomerService />
        </div>
        <div className="step">01 step</div>
        <div className="title">ติดต่อฝ่ายบริการลูกค้า</div>
        <p className="description">{step_1}</p>
      </div>
      <div
        onClick={() => setActiveColumn(1)}
        onKeyPress={(e) => e.key === "13" && setActiveColumn(1)}
        role="button"
        tabIndex={1}
        className={`col step-item ${activeColumn === 1 ? "active-column" : ""}`}
      >
        <div className="icon">
          <Money />
        </div>
        <div className="step">02 step</div>
        <div className="title">ฝากเงิน</div>
        <p className="description">{step_2}</p>
      </div>
      <div
        onClick={() => setActiveColumn(2)}
        onKeyPress={(e) => e.key === "13" && setActiveColumn(2)}
        role="button"
        tabIndex={1}
        className={`col step-item ${activeColumn === 2 ? "active-column" : ""}`}
      >
        <div className="icon">
          <MessageOnPhone />
        </div>
        <div className="step">03 step</div>
        <div className="title">รอรับข้อความสำหรับข้อมูลยูสเซอร์เนมและรหัสผ่าน</div>
        <p className="description">{step_3}</p>
      </div>
    </StepsWrap>
  )
}

export default Steps
